import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'

const getFilters = async () => {
  const response = await axiosGet(apiUrls.filters)

  const data = response.data

  data.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  })

  return data
}

export default getFilters
